import React from 'react'
import styles from './profile-info-head.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import Pupil from './pupil/pupil.container'

const ProfileInfoHead = ({ classes, className }) => (
  <div className={classNames(classes.profileInfoHead, className)}>
    <Pupil />
  </div>
)

export default injectSheet(styles)(ProfileInfoHead)
